export default "__VITE_ASSET__aa2262bd__"